import { useMemo } from 'react';

import { useAppSelector } from '@/store';

import { type HistoryDataSourceInterface } from '../table-data-source';

const usePosCreditHistory = () => {
  const {
    posCredUser: { data: posCredUserData }
  } = useAppSelector((state) => state.posCredApplication);

  const posCreditData: HistoryDataSourceInterface[] | undefined =
    useMemo(() => {
      if (!posCredUserData?.posCreditHistory) return undefined;

      return posCredUserData.posCreditHistory.map((item) => ({
        comment: `${item.comment}: ${item.toStatus.name ? item.toStatus.name : ''}`,
        date: item.createdAt,
        id: `${item.comment}_${item.createdAt}`,
        initiator: item.changedBy ?? ''
      }));
    }, [posCredUserData]);

  return {
    posCreditData,
    totalPosCreditData: posCreditData?.length || 0
  };
};

export default usePosCreditHistory;
